import React from 'react'
import { Box as MuiBox } from "@mui/material"
import { CARD, COLOR, FORMATTING, KEY_VALUES } from "../modules/constants"

const { border1 } = FORMATTING

const Box = ({ variant = 'default', children, ...props }) => {
  const variants = {
    default: {
    },
    container: {
      width: CARD.CONTAINER.WIDTH,
      backgroundColor: CARD.CONTAINER.BACKGROUND_COLOR,
    },
    envelope: {
      display: CARD.ENVELOPE.DISPLAY,
      flexWrap: CARD.ENVELOPE.FLEXWRAP,
      paddingTop: CARD.ENVELOPE.PADDING, // ✅ internal spacing
      margin: CARD.ENVELOPE.MARGIN, // "auto" centralises this div in card container
      // backgroundColor: "rgba(0,0,255,0.1)", // debug: see boundaries
    },
    // Navbar (v12.0.0 "Developer Monitoring Alerts")
    messages: {
      width: "100%",
      marginRight: "40px",
      display: "flex",
      alignItems: "center",
    },
    // Radio buttons bar
    titleBar: {
      minHeight: `${KEY_VALUES.TITLEBAR_HEIGHT}px`,
      width: "100%",
      backgroundColor: COLOR.BACKGROUND,
      position: "relative",
      display: "flex",
      flexWrap: "wrap",
      // flexDirection: "row",
      justifyContent: "center",
      // rowGap: space between wrapped lines (title / radio buttons / pagination), so the title has room
      // to breathe below it too when all three wrap onto separate lines, not just above it
      rowGap: "8px",
      paddingTop: "18px",
      paddingBottom: "2px",
      marginBottom: "0.5px",
      borderBottom: border1,
      // boxShadow: `0px 3px 3px ${COLOR.LIGHT_GREY} inset`,
    },
    // Same as titleBar, but without the bottom divider (portrait Board/Roles pages, where the view
    // toggle buttons render directly underneath and don't need a divider above them)
    titleBarPortrait: {
      minHeight: `${KEY_VALUES.TITLEBAR_HEIGHT}px`,
      width: "100%",
      backgroundColor: COLOR.BACKGROUND,
      position: "relative",
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "center",
      rowGap: "8px",
      paddingTop: "18px",
      paddingBottom: "2px",
      marginBottom: "0.5px",
    },
  }

  return (
    <MuiBox sx={{ ...variants[variant] }} {...props}>
      {children}
    </MuiBox>
  )
}

export default Box